import { render, staticRenderFns } from "./IdSendConf.vue?vue&type=template&id=1e826bbe&"
import script from "./IdSendConf.vue?vue&type=script&lang=js&"
export * from "./IdSendConf.vue?vue&type=script&lang=js&"
import style0 from "./IdSendConf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports